import { pushRoute } from '../../../lib/router.js';
import React from 'react';
import { Button, Col, FormGroup, HelpBlock, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import FieldGroup from '../../FieldGroup.jsx';
import CustomRadio from '../../CustomRadio.jsx';
import OrgStructureCurrentCSVDownloadButton from '../../OrgStructureCurrentCSVDownloadButton.jsx';
import OrgStructureExampleCSVDownloadButton from '../../OrgStructureExampleCSVDownloadButton.jsx';
import { AttentionIconLarge } from '../../icons/AttentionIconLarge.jsx';
import { getOrgSlug } from '../../../lib/utils.js';

export const replaceOptions = [
  { label: 'Add new Employees to existing structure', value: 'add' },
  { label: 'Replace existing structure', value: 'replace' },
];

function EmployeesForm(props) {
  const {
    handleSubmit,
    submitError,
    submitFailed,
    submitting,
    employeesTree,
    replaceMethod,
    setReplaceMethod,
    onDownloadCsv,
    formRef,
  } = props;

  return (
    <form onSubmit={handleSubmit} ref={formRef}>
      {employeesTree.length ? (
        <Row className="m-b-48">
          <Col xs={12}>
            <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
              <h3>Existing Organization Employees</h3>
            </div>
          </Col>
          <Col xs={12}>
            <div className="m-b-18">
              <CustomRadio
                name="replace_method"
                checkedValue={replaceMethod}
                options={replaceOptions}
                action={setReplaceMethod}
              />
            </div>
          </Col>
          <Col xs={6}>
            <div
              className="component-sm component-margin-bottom component-hide-border flex px-26"
              style={{
                background: '#F7FAFD',
                paddingLeft: '26px',
                paddingRight: '26px',
              }}
            >
              <div style={{ width: '30px' }}>
                <AttentionIconLarge />
              </div>
              <p className="text-muted m-b-0 m-l-16">
                Please note that you are updating the organizational structure
                for both groups and employees. Ensure both are included in the
                CSV file for proper updates. We recommend downloading the
                current CSV, editing it, and re-uploading to align with the new
                structure.
              </p>
            </div>
          </Col>
          <Col xs={12}>
            <OrgStructureCurrentCSVDownloadButton
              onDownloadCsv={onDownloadCsv}
            />
          </Col>
        </Row>
      ) : null}

      <Row className="m-b-48">
        <Col xs={12}>
          <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
            <h3>Bulk CSV Upload</h3>
          </div>
        </Col>
        <Col xs={12}>
          <div className="m-b-18">
            <OrgStructureExampleCSVDownloadButton />
          </div>
        </Col>
        <Col xs={12}>
          <Field
            id="groupsFormCsvFile"
            name="csv_file"
            type="file"
            component={FieldGroup}
            accept=".csv"
          />
        </Col>
      </Row>

      <Row className="m-b-48">
        {submitFailed && (
          <Col xs={12}>
            <FormGroup validationState="error">
              <HelpBlock>
                {submitError || 'Please fill in all required fields'}
              </HelpBlock>
            </FormGroup>
          </Col>
        )}
        <Col xs={12}>
          <div className="flex">
            <div>
              <Button
                bsStyle="default"
                onClick={() =>
                  pushRoute(`/${getOrgSlug()}/organization/employees`)
                }
              >
                Cancel
              </Button>

              <Button
                className="m-l-12"
                bsStyle="primary"
                disabled={submitting}
                type="submit"
              >
                {submitting ? 'Saving...' : 'Save'}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </form>
  );
}

export default EmployeesForm;
